export default __webpack_public_path__ + "static/media/economics-en.9ae06492.png";